import { render, staticRenderFns } from "./ValoresObtenidosForm.vue?vue&type=template&id=146e0045&"
import script from "./ValoresObtenidosForm.vue?vue&type=script&lang=ts&"
export * from "./ValoresObtenidosForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports